class Group {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-aco').click(function () {
      $(this).next('div').slideToggle();
      $(this).toggleClass('active');
    });

    $(function () {
      $(".js-content:first-of-type").addClass("is-active");
      var contentH = "auto";
      $(".js-block").css("height" , contentH);
      $(".js-tab").on("click", function () {
        $(".is-active").removeClass("is-active");
        $(this).addClass("is-active");
        const index = $(this).index();  
        if(index == 1){
          contentH = $(".js-content").eq(index).height();
          $(".js-block").css("height" , contentH);
        } else {
          $(".js-block").css("height" , "auto");
        }
        $(".js-content").eq(index).addClass("is-active");
      });
    });

    $(function () {
      $(".js-map a[href^='#']").on("click", function () {
        $(".js-content:first-of-type").removeClass("is-active");
        $(".js-content:last-of-type").addClass("is-active");
        $(".js-tab:first-of-type").removeClass("is-active");
        $(".js-tab:last-of-type").addClass("is-active");
        var contentH = $(".js-content:last-of-type").height();
        $(".js-block").css("height" , contentH);
      });
    });
  }
}